import { render, staticRenderFns } from "./ViewerStatusBar.vue?vue&type=template&id=274c7e5a&scoped=true"
import script from "./ViewerStatusBar.vue?vue&type=script&lang=js"
export * from "./ViewerStatusBar.vue?vue&type=script&lang=js"
import style0 from "./ViewerStatusBar.vue?vue&type=style&index=0&id=274c7e5a&prod&lang=scss&scoped=true"
import style1 from "./ViewerStatusBar.vue?vue&type=style&index=1&id=274c7e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c7e5a",
  null
  
)

export default component.exports